<template>
  <div class="c-invites-results">
    <p v-if="invites.length > 1" class="count-tag">
      {{ invites.length }} convites encontrados
    </p>
    <p v-else class="count-tag">{{ invites.length }} convite encontrado</p>

    <div
      v-for="invite in invites"
      @click="$emit('selected', invite)"
      :key="invite.id"
      class="invite"
    >
      <div class="description">
        <p class="name">{{ invite.name }}</p>
        <p class="phone">
          Tel.: <span class="uppercase">{{ invite.phone }}</span>
        </p>
      </div>
      <div class="action link">
        Selecionar
        <base-icon width="12" height="12" name="painel/chevron-left-icon" />
      </div>
    </div>

    <button @click="$emit('resetSearch')" class="link" type="button">
      Realizar nova pesquisa
      <base-icon width="12" height="12" name="painel/chevron-left-icon" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    invites: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.c-invites-results {
  .link {
    margin-top: 32px;
  }

  .invite {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    cursor: pointer;
    padding: 16px 24px;
    margin-top: 16px;
    border-radius: 8px;
    border: 1px solid rgba($neutrallight, 0.5);
    &:first-child {
      margin-top: 0;
    }
    &:hover {
      box-shadow: 0px 0px 3px 0px $neutrallight;
      .link {
        color: $tertiarydarkest;
      }
    }
    @media screen and (min-width: $mobile) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .description {
      text-align: left;
      .name {
        margin-bottom: 8px;
        color: $neutral;
        font-size: 16px;
        font-weight: 700;
        line-height: 1;
      }
      .phone {
        color: $neutrallight;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        .uppercase {
          text-transform: uppercase;
        }
      }
    }

    .action {
      display: flex;
      align-items: center;
      margin-top: 24px;
      @media screen and (min-width: $mobile) {
        margin-top: 0;
      }
    }
  }
}
</style>
